import React, { useContext } from "react";
import { Controller, useWatch } from "react-hook-form";
import { Button, Dialog } from "iuvity-ui-components";
import { MultiSelect } from "primereact/multiselect";
import { DialogProps } from "../dialog/CustomDialog";
import { ApplicationCreatorSchema } from "../../validations/schemas";
import { REVALIDATE_FORM_PROPS } from "../../constants";
import { AppContext } from "../../context/index";

interface FilterDialogProps extends DialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  data: any;
  setData: React.Dispatch<React.SetStateAction<any>>;
  onClearFilters: Function;
  form: any;
  formOptions: any;
}

export const FilterDialog: React.FC<FilterDialogProps> = ({
  visible,
  setVisible,
  data,
  setData,
  onClearFilters,
  form,
  formOptions,
}) => {
  const {
    t,
    appState: { pageFilter },
    setAppState,
  } = useContext(AppContext);
  const { control, setValue } = form;

  const functionalityValues = useWatch({
    control,
    name: "functionality",
  });

  const versionValues = useWatch({
    control,
    name: "version",
  });

  const onCloseModal = () => {
    document.body.style.overflowY = "auto";
    setVisible(false);
  };

  const onFilter = () => {
    const formValues = form.getValues();
    setData(
      data.filter((item: any) => {
        return (
          (functionalityValues.length > 0
            ? functionalityValues.includes(item.functionality)
            : true) &&
          (versionValues.length > 0
            ? versionValues.includes(item.version)
            : true)
        );
      })
    );
    document.body.style.overflowY = "auto";
    setVisible(false);
    form.reset(formValues);
    if (JSON.stringify(formValues) !== JSON.stringify(pageFilter)) {
      setAppState((prev) => ({
        ...prev,
        pageFilter: formValues,
      }));
    }
  };

  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-flex-end">
        <Button
          className="mr-4"
          label={t("Translations.clearFilterBtnLabel")}
          variant="p-button-link"
          onClick={() => onClearFilters()}
        />
        <Button
          label={t("Translations.filterBtnLabel2")}
          variant="p-button"
          disabled={
            !(functionalityValues.length > 0 || versionValues.length > 0)
          }
          onClick={onFilter}
        />
      </div>
    );
  };

  return (
    formOptions && (
      <Dialog
        id="dialogScroll1"
        className="dialog-form"
        header={t("Translations.filterDialogTitle")}
        visible={visible}
        onHide={onCloseModal}
        style={{ width: "35rem" }}
        footer={renderFooter}
      >
        <div className="form lg">
          {["functionality", "version"].map((key) => {
            return (
              <div key={key}>
                <Controller
                  name={key}
                  control={control}
                  rules={(ApplicationCreatorSchema(t) as any)[key]}
                  render={({ field }) => {
                    field.onChange = (e) => {
                      const valuesToUpdate = [...e.value];

                      if (
                        valuesToUpdate.some(
                          (item: string) =>
                            ["products", "transfers"].includes(item) &&
                            !e.value.includes("mappedfields")
                        )
                      ) {
                        valuesToUpdate.push("mappedfields");
                      }

                      if (
                        valuesToUpdate.includes("products") &&
                        !valuesToUpdate.includes("productproperties")
                      ) {
                        valuesToUpdate.push("productproperties");
                      }

                      if (
                        valuesToUpdate.includes("transfers") &&
                        !valuesToUpdate.includes("transactionproperties")
                      ) {
                        valuesToUpdate.push("transactionproperties");
                      }

                      setValue(
                        field.name,
                        valuesToUpdate,
                        REVALIDATE_FORM_PROPS
                      );
                    };
                    return (
                      <>
                        <label htmlFor={key} className="block lb mt-2 mb-1">
                          {t(`${`Environments.${key}Label`}`)}
                        </label>
                        <MultiSelect
                          id={`select-widget`}
                          display="chip"
                          placeholder={t(`Environments.${key}Placeholder`)}
                          className="mb-4"
                          options={(formOptions as any)[key]}
                          emptyFilterMessage={t(
                            "Translations.noAvailableMessage"
                          )}
                          filter
                          {...field}
                        />
                      </>
                    );
                  }}
                />
              </div>
            );
          })}
        </div>
      </Dialog>
    )
  );
};
